import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, ACCOUNT_TYPES, EMAIL, COUNTRIES_LIST } from "../../appconstants";
import {
  CancelButton,
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  Text
} from "../../design";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { getLocationDetails } from "../../api";
import { AmountDivideByHundred } from "../../helper";
import { State as ListofStates } from 'country-state-city';

const postalCodes = require('postal-codes-js');

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  alpha2: string,
  disableButtonText: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  showWhatsAppNotify: boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  tax: Number;
  discount: Number;
  totalPayable: Number,
  subTotal: Number,
  isBillingAdressRequired: Boolean,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  prefix: string,
}

const XAchPayment = (props: Props) => {
  const { submit, preFillCustomer, customerDisabled, showWhatsAppNotify, isBillingAdressRequired,
    headerText, buttonText, errorHeader, errorMsg, sitekey, isCaptchaEnabled, discount,
    customerValidation, alpha2, disableButtonText, planStartDate, currentDateObject, showCancelBtn, cancel, cancelButtonText,
    serviceFeeRateVal, amount, serviceFeeVal, serviceFee, serviceFeeRate, tip, prefix, tax, totalPayable, subTotal,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [pinCode, setPinCode] = useState(null);
  const [billStatesList, setBillStatesList] = useState([{}]);
  const postalCode = 'Postal Code';
  const pincodeLabel = 'Postal Code';
  const [countryNameCode, setCountryNameCode] = useState();

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
  } = useForm();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  useEffect(() => {
    if (alpha2 && isBillingAdressRequired) {
      getDefaultCountryPostal();
    }
  }, [alpha2, isBillingAdressRequired]);

  useEffect(() => {
    reset({
      country: defaultCountry || "",
      zipCode: pinCode || "",
    })
  }, [pinCode]);

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = countryNameCode || (defaultCountry && defaultCountry.code);
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const getDefaultCountryPostal = async () => {
    try {
      const data = await getLocationDetails();
      const payLoad = {
        "name": data && data.country_name,
        "code": data && data.country
      }
      setDefaultCountry(payLoad);
      setPinCode(data && data.postal);
      const countryStates = ListofStates.getStatesOfCountry(data && data.country);
      setBillStatesList(countryStates);
    } catch (e) {
      console.log(e);
    }
  };

  const callBackStatelist = async (data) => {
    const countryStates = ListofStates.getStatesOfCountry(data && data.code);
    const payLoad = {
      "name": data && data.name,
      "code": data && data.code
    }
    setDefaultCountry(payLoad);
    reset({
      billstate: "",
      country: payLoad,
    })
    setBillStatesList(countryStates);
  }

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [reset, preFillCustomer]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const customStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      marginTop: "8px"
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important'
    }),
  };

  const disableStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    const { name, email, phone, countryCallingCode, zipCode, country, postalCode, bankName, accountType, notify, accountNumber, routingNumber, accountHolderName } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const BankName = bankName.trim();
    const Name = accountHolderName.trim();
    const Route = routingNumber.trim();
    const AccountNum = accountNumber.trim();
    const paymentMethod = {
      type: "X_ACH", postalCode: postalCode ? postalCode : zipCode, countryCode: country && country.code, bank: { bankName: BankName, accountType: accountType.value, accountNumber: AccountNum, routingNumber: Route, name: Name },
      paymentMethodBillingAddress: isBillingAdressRequired ? {
        city: data.billcity || null, countryCode: (country && country.code) || null, state: (data.billstate && (data.billstate.isoCode === 'TG' ? 'TS' : (data.billstate.isoCode === 'UT' ? 'UK' : (data.billstate.isoCode === 'DH' ? 'DN' : data.billstate.isoCode)))) || null,
        street: data.billaddress ? `${data.billaddress}, ${data.billaddress1 || ''}` : null
      }
        : null,
    };
    const finalData = { ...data, phoneNumber, customer, notify, paymentMethod, recaptchaToken };
    console.log(finalData, 'finalData');
    if (submit) { submit(finalData) }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  return (
    <>
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        {headerText || "Pay With X ACH"}
      </H1Text>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        onChange={() => setShowErrorMessage(false)}
        style={{
          width: '100%',
        }}
      >
        <FlexContainer
          flexDirection="column"
        >
          <div className="px-1 px-md-4 mt-2">
            <LabelText>
              Name
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.name ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="name"
              placeholder="Enter your name"
              rules={customerValidation && {
                required: 'This field is required'
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : ''
                }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              E-Mail
            </LabelText>
            <Controller
              marginBottom="0px"
              defaultValue={""}
              color={errors.email ? "red" : "inherit"}
              control={control}
              name="email"
              placeholder="Enter your email address"
              rules={customerValidation && {
                required: 'This field is required',
                pattern: {
                  value: EMAIL.DEFAULT_REGEX,
                  message: 'The email is invalid',
                },
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : ''
                }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              Phone
            </LabelText>
            <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='299px'>
              <Controller
                defaultValue={""}
                color={errors.countryCallingCode ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="countryCallingCode"
                placeholder="select"
                rules={customerValidation && {
                  required: 'Calling Code is required'
                }}
                as={<Select
                  className="col-4 px-0 border-0"
                  menuPlacement="auto"
                  isSearchable={!customerDisabled}
                  menuIsOpen={customerDisabled ? false : undefined}
                  theme={theme => ({
                    ...theme,
                    borderRadius: "4px 0 0 4px",
                    boxShadow: 0
                  })}
                  getOptionLabel={(option) => option.value}
                  styles={customerDisabled ? disableStyles : phoneCustomStyles}
                  options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
              />
              <Controller
                className="col"
                defaultValue={""}
                color={errors.phone ? "red" : "inherit"}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                paddingRight="0"
                control={control}
                name="phone"
                rules={customerValidation && {
                  required: 'This field is required',
                  validate: isPhoneNumberValidate
                }}
                as={<NumberFormat
                  type="tel"
                  allowNegative={false}
                  decimalScale={0}
                  readOnly={customerDisabled}
                  borderRadius="none"
                  style={{
                    background: customerDisabled ? BACKGROUND_COLOR : '',
                    color: customerDisabled ? COLOR : ''
                  }}
                />}
                placeholder="Enter your phone number"
                customInput={Input}
              />
            </InputWrapper>
            <ErrorMessage
              errors={errors}
              name="phone"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            {/* {
              showWhatsAppNotify && (
                <div className="mt-3">
                  <label>
                    <Controller
                      marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                        defaultChecked={checked}
                        onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
                    <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                </div>
              )
            } */}
            {
              sitekey && (isCaptchaEnabled === true) && (
                <div className="mt-3">
                  <ReCAPTCHA
                    sitekey={sitekey}
                    value={recaptchaToken}
                    onChange={(value) => {
                      setRecaptchToken(value);
                      setShowCaptchError(null);
                    }}
                  />
                  {
                    (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                    ) : showCaptchError ? (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                    ) : ''
                  }
                </div>
              )
            }
            <Hr />
            <LabelText>
              Bank Name
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.bankName ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="bankName"
              placeholder="Enter bank name"
              rules={{
                required: 'This field is required',
                pattern: {
                  value: /^[a-zA-Z ]+$/,
                  message: 'Bank name must be valid',
                },
              }}
              as={Input}
            />
            <ErrorMessage
              errors={errors}
              name="bankName"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              Account Type
            </LabelText>
            <div style={{
              width: "299px"
            }}>
              <Controller
                defaultValue={""}
                color={errors.accountType ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="accountType"
                placeholder="select"
                rules={{
                  required: 'Account type is required'
                }}
                as={<Select
                  className="px-0 border-0"
                  theme={theme => ({
                    ...theme,
                    borderRadius: "4px",
                    boxShadow: 0,
                  })}
                  getOptionLabel={(option) => option.value}
                  styles={customStyles}
                  options={ACCOUNT_TYPES.map(value => { return { value } })} />}
              />
              <ErrorMessage
                errors={errors}
                name="accountType"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </div>
            <LabelText>
              Account Holder Name
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.accountHolderName ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="accountHolderName"
              placeholder="Enter account holder name"
              rules={{
                required: 'This field is required',
                pattern: {
                  value: /^[a-zA-Z ]+$/,
                  message: 'Account holder name must be valid',
                },
              }}
              as={Input}
            />
            <ErrorMessage
              errors={errors}
              name="accountHolderName"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              Bank Account Number
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.accountNumber ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="accountNumber"
              placeholder="Enter account number"
              rules={{
                required: 'This field is required',
                pattern: {
                  value: /^\s*[0-9]{6,17}\s*$/,
                  message: 'The account number is invalid',
                },
              }}
              as={Input}
            />
            <ErrorMessage
              errors={errors}
              name="accountNumber"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              Routing Number
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.routingNumber ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="routingNumber"
              placeholder="Enter routing number"
              rules={customerValidation && {
                required: 'This field is required',
                pattern: {
                  value: /^\s*[0-9]{9}\s*$/,
                  message: 'The routing number is invalid',
                },
              }}
              as={Input}
            />
            <ErrorMessage
              errors={errors}
              name="routingNumber"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            {
              isBillingAdressRequired ? (
                <>
                  <Hr />
                  {
                    <>
                      {defaultCountry && (
                        <div>
                          <>
                            <LabelText className="mb-2">
                              Billing Address
                            </LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.billaddress ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billaddress"
                              placeholder="Address"
                              rules={{
                                required: 'Address is required',
                              }}
                              as={Input}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billaddress"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                            <LabelText />
                            <Controller
                              defaultValue={""}
                              color={errors.billaddress1 ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billaddress1"
                              placeholder="Address2"
                              as={Input}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billaddress1"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                            <LabelText />
                            <Controller
                              defaultValue={""}
                              color={errors.billcity ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billcity"
                              placeholder="City"
                              rules={{
                                required: 'City is required',
                              }}
                              as={Input}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billcity"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                            <LabelText />
                            <div style={{
                              width: "299px"
                            }}>
                              <Controller
                                defaultValue={""}
                                color={errors.billstate ? "red" : "inherit"}
                                marginBottom="0px"
                                marginTop="8px"
                                border="0px !important"
                                control={control}
                                name="billstate"
                                placeholder="State"
                                rules={{
                                  required: 'State is required'
                                }}
                                as={<Select
                                  theme={theme => ({
                                    ...theme,
                                    borderRadius: "4px",
                                    boxShadow: 0,
                                  })}
                                  // menuIsOpen={true}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.isoCode}
                                  options={billStatesList} />}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="billstate"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                              <LabelText />
                              <Controller
                                marginTop="8px !important"
                                marginBottom="0px"
                                defaultValue={""}
                                color={errors.zipCode ? "red" : "inherit"}
                                control={control}
                                name="zipCode"
                                isSearchable="true"
                                placeholder={postalCode}
                                rules={{
                                  required: `${pincodeLabel} is required`,
                                  validate: isZipcodeValidate1
                                }}
                                as={<Input style={{
                                  marginTop: "0px",
                                  marginBottom: "0px",
                                  width: "299px",
                                  borderRadius: "0px 0px 4px 4px",
                                }}
                                  type="text"
                                  name="zipCode"
                                  // onInput={event => {
                                  //   getCountryCode(event.target.value);
                                  // }}
                                  placeholder="Enter your card number"
                                />}
                                customInput={Input}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="zipCode"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="billzipCode"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                            </div>
                            <div style={{
                              width: "299px",
                              marginTop: "16px"
                            }}>
                              <Controller
                                defaultValue={''}
                                color={errors.country ? "red" : "inherit"}
                                marginBottom="0px"
                                control={control}
                                name="country"
                                placeholder="Select a country"
                                rules={{
                                  required: 'Country is required'
                                }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    className="px-0 border-0"
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: '4px',
                                      boxShadow: 0,
                                    })}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.code}
                                    styles={customStyles}
                                    options={COUNTRIES_LIST}
                                    defaultValue={defaultCountry}
                                    placeholder="Country"
                                    onChange={(event) => {
                                      callBackStatelist(event);
                                      setCountryNameCode(event.code);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="country"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                            </div>
                          </>
                        </div>
                      )}
                    </>
                  }
                </>
              ) : ''
            }
            {
              (serviceFeeEnabled === true) && (
                <div className="px-1 px-md-4">
                  <div class="mt-4">
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Amount:</th>
                          <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                        </tr>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Service Fee:</th>
                          <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                        </tr>
                        <tr style={{ background: '#F7F7F7' }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )
            }
            {
              (serviceFee || serviceFeeRate || discount || subTotal) && (
                <div class="mt-4">
                  <Hr />
                  <table class="table table-bordered mt-4">
                    <tbody>
                      <tr style={{ borderBottom: 'hidden' }}>
                        <th scope="row">Amount:</th>
                        <td>{prefix} {AmountDivideByHundred(amount)}</td>
                      </tr>
                      {
                        discount && discount !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Discount:</th>
                            <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        subTotal && subTotal !== 0 ? (
                          <tr>
                            <th scope="row">Sub Total:</th>
                            <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        tax && tax !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Tax:</th>
                            <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        serviceFeeVal && serviceFeeVal !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Service Fee:</th>
                            <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {
                        tip && tip !== 0 ? (
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Tip:</th>
                            <td>{prefix} {AmountDivideByHundred(tip)}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      <tr style={{ background: '#F7F7F7' }}>
                        <th scope="row">Total Payable:</th>
                        <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
            <div className="px-1 px-md-4">
              <FlexContainer
                width="100%"
                alignItems="center"
                justifyContent="space-between"
              >
                {
                  showCancelButton && cancel &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    color="#40A9FF"
                    className="cursor-pointer m-3 pt-3"
                  >{cancelButtonText || "Cancel"}</SpanText>
                }
                {disableButtonText && (planStartDate < currentDateObject) ?
                  (
                    <SubmitButton
                      type="submit"
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (
                    <SubmitButton
                      type="submit"
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                }
              </FlexContainer>
              {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />}
              {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
            </div>
          </div>
        </FlexContainer>
      </form>
    </>
  )
};

export default XAchPayment;
